import { InjectionToken } from '@angular/core';
export interface MastercardTranslations {
  noProductDetails: string;
  noTechnicalDetails: string;
  compare: string;
  ariaCompareAdd: string;
  ariaCompareRemove: string;
  errorHeadline: string;
  contactUs: string;
  fromPricePrefix: string;
  quantity: string;
  totalPieces: string;
  selectText: string;
  selectedText: string;
}

export const MastercardDefaultTranslations: MastercardTranslations = {
  noProductDetails: 'No details available',
  noTechnicalDetails: 'No technical data available',
  compare: 'Compare',
  ariaCompareAdd: 'Add {{item}} to compare',
  ariaCompareRemove: 'Remove {{item}} from compare',
  errorHeadline: 'Error Occurred',
  contactUs: 'Please contact us',
  fromPricePrefix: 'From',
  quantity: 'Quantity',
  totalPieces: 'Total Pieces',
  selectText: 'Select',
  selectedText: 'Remove'
};

export const MASTERCARD_TRANSLATIONS = new InjectionToken<MastercardTranslations>('MASTERCARD_TRANSLATIONS');
